<template>
  <div>
    <div v-if="user">
      <h1>TODO: FAQ Page ...</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "faq",
  props: ["user"]
};
</script>
